<template>
  <div class="nko-detail-projects-item">
    <svg
      v-if="screenWidth < 768"
      class="nko-detail-mobile-icon"
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M69.3295 28.2344V65.8814H10.9766V28.2344H26.1781L24.4668 32.9403L40.153 54.901L55.8393 32.9403L54.1279 28.2344H69.3295Z" fill="#A4AADA"/>
      <path d="M78.7451 64.3137H77.1765V26.6667C77.1765 23.2069 74.3617 20.3922 70.902 20.3922H52.949L51.8082 17.2549H53.4902C54.3564 17.2549 55.0588 16.5525 55.0588 15.6863V7.84314C55.0588 6.97694 54.3564 6.27451 53.4902 6.27451H50.3529V1.56863C50.3529 0.702431 49.6505 0 48.7843 0H31.5294C30.6631 0 29.9608 0.702431 29.9608 1.56863V6.27451H26.8235C25.9572 6.27451 25.2549 6.97694 25.2549 7.84314V15.6863C25.2549 16.5525 25.9572 17.2549 26.8235 17.2549H28.5056L27.3647 20.3922H9.41177C5.952 20.3922 3.13725 23.2069 3.13725 26.6667V64.3137H1.56863C0.702275 64.3137 0 65.0162 0 65.8824V73.7255C0 77.1853 2.81475 80 6.27451 80H74.0392C77.499 80 80.3137 77.1853 80.3137 73.7255V65.8824C80.3137 65.0162 79.6113 64.3137 78.7451 64.3137ZM33.098 3.13725H47.2157V6.27451H33.098V3.13725ZM28.3922 9.41177H51.9216V14.1176C48.4223 14.1176 31.5062 14.1176 28.3922 14.1176V9.41177ZM48.47 17.2549L54.0868 32.7013L41.7255 50.0071V35.8085C43.5512 35.1611 44.8627 33.4174 44.8627 31.3726C44.8627 28.7777 42.7517 26.6667 40.1569 26.6667C37.562 26.6667 35.451 28.7777 35.451 31.3726C35.451 33.4174 36.7625 35.1611 38.5882 35.8085V50.0071L26.227 32.7013L31.8438 17.2549H48.47ZM40.1569 32.9412C39.2919 32.9412 38.5882 32.2375 38.5882 31.3726C38.5882 30.5076 39.2919 29.8039 40.1569 29.8039C41.0218 29.8039 41.7255 30.5076 41.7255 31.3726C41.7255 32.2375 41.0218 32.9412 40.1569 32.9412ZM6.27451 26.6667C6.27451 24.9368 7.68188 23.5294 9.41177 23.5294H26.224L22.9964 32.405C22.8198 32.8908 22.8938 33.4323 23.1942 33.8529L37.1087 53.3333H26.5537C25.9062 51.5076 24.1625 50.1961 22.1176 50.1961C19.5228 50.1961 17.4118 52.3071 17.4118 54.902C17.4118 57.4968 19.5228 59.6078 22.1176 59.6078C24.1625 59.6078 25.9062 58.2963 26.5537 56.4706H53.76C54.4077 58.2963 56.1512 59.6078 58.1961 59.6078C60.7909 59.6078 62.902 57.4968 62.902 54.902C62.902 52.3071 60.7909 50.1961 58.1961 50.1961C56.1512 50.1961 54.4077 51.5076 53.76 53.3333H43.2052L57.1197 33.8529C57.4201 33.4322 57.4941 32.8907 57.3173 32.405L54.0897 23.5294H70.902C72.6318 23.5294 74.0392 24.9368 74.0392 26.6667V64.3137C70.374 64.3137 7.84737 64.3137 6.27451 64.3137V26.6667ZM23.6863 54.902C23.6863 55.7669 22.9826 56.4706 22.1176 56.4706C21.2527 56.4706 20.549 55.7669 20.549 54.902C20.549 54.037 21.2527 53.3333 22.1176 53.3333C22.9826 53.3333 23.6863 54.037 23.6863 54.902ZM56.6275 54.902C56.6275 54.037 57.3311 53.3333 58.1961 53.3333C59.061 53.3333 59.7647 54.037 59.7647 54.902C59.7647 55.7669 59.061 56.4706 58.1961 56.4706C57.3311 56.4706 56.6275 55.7669 56.6275 54.902ZM33.098 67.451H47.2157V70.5882H33.098V67.451ZM77.1765 73.7255C77.1765 75.4554 75.7691 76.8627 74.0392 76.8627H6.27451C4.54463 76.8627 3.13725 75.4554 3.13725 73.7255V67.451H29.9608V72.1569C29.9608 73.0231 30.6631 73.7255 31.5294 73.7255H48.7843C49.6505 73.7255 50.3529 73.0231 50.3529 72.1569V67.451H77.1765V73.7255Z" fill="#2F3941"/>
    </svg>

    <div class="nko-detail-header">
      <h4 class="nko-detail-header__title">
        Оформление рекламного баннера
      </h4>
      <time class="nko-detail-header__time">
        Дедлайн 12.02.22
      </time>
    </div>
    <div class="nko-detail-footer">
      <div
        v-if="screenWidth >= 768"
        class="nko-detail-professions"
      >
        <span class="nko-detail-professions__item">
          Копирайтинг
        </span>
        <span class="nko-detail-professions__item">
          Маркетинг, PR
        </span>
      </div>
      <div class="nko-detail-aside">
        <div class="nko-detail-reviews">
          <!-- 3 = array.length -->
          <div
            class="nko-detail-reviews__pictures"
            :style="`width: ${ (20 * 3) - ((3 - 1) * 10) }px`"
          >
            <img
              v-for="(item, key) in 3"
              :key="key"
              :style="`
                transform: translateX(-${ key }0px);
                z-index: ${ 3 - key }
              `"
              :src="`/local/templates/main/img/nko/review-${ item }.png`"
              alt=""
              class="nko-detail-reviews__picture"
            >
<!--            <img-->
<!--              src="/local/templates/main/img/nko/review-2.png"-->
<!--              alt=""-->
<!--              class="nko-detail-reviews__picture"-->
<!--            >-->
<!--            <img-->
<!--              src="/local/templates/main/img/nko/review-3.png"-->
<!--              alt=""-->
<!--              class="nko-detail-reviews__picture"-->
<!--            >-->
          </div>
          <p class="nko-detail-reviews__count">
            12 откликов
          </p>
        </div>
        <p class="nko-detail-star">
          <svg class="nko-detail-star__icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.9635 5.06994C13.8719 4.78645 13.6204 4.58511 13.3229 4.5583L9.28216 4.19139L7.68432 0.451504C7.56651 0.177419 7.29819 0 7.00007 0C6.70195 0 6.43364 0.177419 6.31582 0.452145L4.71798 4.19139L0.67656 4.5583C0.379616 4.58575 0.128816 4.78645 0.0366355 5.06994C-0.0555452 5.35342 0.0295858 5.66436 0.254216 5.86036L3.30857 8.53905L2.40791 12.5065C2.34201 12.7982 2.45523 13.0997 2.69727 13.2747C2.82737 13.3687 2.97958 13.4165 3.13307 13.4165C3.26542 13.4165 3.39669 13.3808 3.51451 13.3103L7.00007 11.2271L10.4844 13.3103C10.7393 13.4637 11.0607 13.4497 11.3022 13.2747C11.5444 13.0992 11.6575 12.7975 11.5916 12.5065L10.6909 8.53905L13.7453 5.8609C13.9699 5.66436 14.0557 5.35396 13.9635 5.06994Z" fill="#68737D"/>
          </svg>
          1/4
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NkoDetailProjectsItem',
  props: ['result'],
}
</script>

<style lang="scss" scoped>
.nko-detail-projects-item {
  background: #FFFFFF;
  border-radius: 6px;
  padding: 30px;
  @include tablet{
    padding: 30px 23px;
  }
  @include mobile{
    padding: 22px;
  }
}
.nko-detail-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 31px;
  border-bottom: 1px solid #E9EBED;
  @include mobile{
    flex-direction: column;
    border-bottom: unset;
    align-items: flex-start;
  }
  &__title{
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 0;
    @include mobile{
      margin-bottom: 45px;
    }
  }
  &__time{
    border: 1px solid #E9EBED;
    border-radius: 6px;
    padding: 10px 14px;
    font-size: 14px;
    line-height: 20px;
    color: #68737D;
  }
}
.nko-detail-footer{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  @include mobile{
    flex-direction: column;
    align-items: flex-start;
    padding-top: 0;
  }
}
.nko-detail-professions{
  display: flex;
  flex-wrap: wrap;
  &__item{
    font-size: 14px;
    line-height: 20px;
    color: #6367A7;
    border: 1px solid #A4AADA;
    border-radius: 6px;
    padding: 10px 14px;
    &:not(:last-child){
      margin-right: 11px;
    }
  }
}
.nko-detail-aside{
  display: flex;
  align-items: center;
  @include mobile{
    align-self: stretch;
    justify-content: space-between;
    //padding-top: 34px;
  }
}
.nko-detail-reviews{
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-column-gap: 7px;
  margin-right: 31px;
  &__pictures{
    display: flex;
  }
  &__picture{
    width: 20px;
    height: 20px;
  }
  &__count{
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    color: #00A59E;
    margin-bottom: 0;
  }
}
.nko-detail-star{
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  color: #68737D;
  margin-bottom: 0;
  &__icon{
    margin-right: 5px;
  }
}
.nko-detail-mobile-icon{
  width: 80px;
  height: 80px;
  margin-bottom: 52px;
}
</style>